import { useEffect, useRef, useState } from 'react';
import { setRunnerAddress } from '../../chains/evm/api';
import { AVAILABLE_EVM_CHAINS, isEVMChain } from '../../wallet/chains';
import { DEFAULT_DAPP_STATE } from '../constants';
function toWeiBigInt(value) {
    if (value == null)
        return BigInt(0);
    if (typeof value === 'bigint')
        return value;
    if (typeof value === 'number')
        return BigInt(Math.trunc(value));
    if (typeof value === 'string')
        return BigInt(value);
    return BigInt(0);
}
function isAlmostSameBalance(a, b) {
    const delta = Number(toWeiBigInt(a) - toWeiBigInt(b)) / 1e18;
    return Math.abs(delta) < 1e-6;
}
export function useEvmEffects({ initStatus, activeChain, evmSigner, evmBalanceValue, balances, setBalances, walletAddresses, setWalletAddresses, incomingConnection, setIncomingConnection, updateAllEVMChains, updateChainState, isWalletAuthenticated, }) {
    const [isSwitching, setIsSwitching] = useState(false);
    // Last evmBalanceValue already synced per chain — guards against an infinite
    // loop when updateChainState re-fetches a stale balance and re-triggers this effect.
    const prevBalancesRef = useRef({});
    const wasAuthenticatedRef = useRef(false);
    useEffect(() => {
        if (!initStatus.evm)
            return;
        if (incomingConnection.network && incomingConnection.wallet == null) {
            if (walletAddresses.evm &&
                evmSigner?.address == undefined &&
                balances[activeChain] != undefined &&
                evmBalanceValue == undefined) {
                setIsSwitching(true);
            }
            else if (walletAddresses.evm &&
                evmSigner?.address &&
                walletAddresses.evm &&
                balances[activeChain] != undefined &&
                evmBalanceValue != undefined &&
                isSwitching) {
                setIncomingConnection({ network: null, wallet: null });
                setIsSwitching(false);
            }
        }
        else if (walletAddresses.evm != evmSigner?.address) {
            setWalletAddresses((prev) => ({
                ...prev,
                evm: evmSigner?.address,
            }));
            console.log('EVM Wallet address changed', evmSigner?.address);
            AVAILABLE_EVM_CHAINS.forEach((chain) => {
                if (DEFAULT_DAPP_STATE[chain]) {
                    setRunnerAddress(chain, evmSigner?.address);
                }
            });
            // Global/public data only until wallet sign-in completes.
            updateAllEVMChains(false);
        }
        else if (isEVMChain(activeChain) &&
            !isAlmostSameBalance(balances[activeChain], evmBalanceValue) &&
            !isAlmostSameBalance(prevBalancesRef.current[activeChain], evmBalanceValue)) {
            console.log(`${activeChain} balance changed ${balances[activeChain]} => ${evmBalanceValue}`);
            prevBalancesRef.current[activeChain] = toWeiBigInt(evmBalanceValue);
            setBalances((prev) => ({
                ...prev,
                [activeChain]: evmBalanceValue,
            }));
            updateChainState(activeChain, false, true);
        }
    }, [
        evmSigner,
        walletAddresses.evm,
        evmBalanceValue,
        balances,
        activeChain,
        initStatus.evm,
        incomingConnection,
        isSwitching,
    ]);
    // After wallet challenge succeeds, load personal on-chain + /owned data once.
    useEffect(() => {
        if (!initStatus.evm)
            return;
        const justAuthenticated = isWalletAuthenticated && !wasAuthenticatedRef.current;
        wasAuthenticatedRef.current = isWalletAuthenticated;
        if (!justAuthenticated || !evmSigner?.address)
            return;
        updateAllEVMChains(true);
    }, [initStatus.evm, isWalletAuthenticated, evmSigner?.address, updateAllEVMChains]);
}
